import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { getInitPage, parseSearch } from "../../utils/platform";

export function withScrollTo(WrappedComp, anchor) {
  return function WithScrollTo(props) {
    const location = useLocation(); // 从 React Router v6 获取 location
    const page = getInitPage(parseSearch(location.search)); // 解析 URL 参数

    useEffect(() => {
      setScrollTop();
    }, [page]); // 当 page 变化时触发滚动

    function setScrollTop() {
      let anchorDom = null;
      let top = 0;
      const anchorType = typeof anchor;

      if (anchorType === "object") {
        anchorDom = anchor;
      } else if (anchorType === "string") {
        anchorDom =
          anchor.indexOf("#") === 0
            ? document.getElementById(anchor.substring(1))
            : document.querySelector(anchor);
      } else if (anchorType === "number") {
        top = anchor;
      }

      if (anchorDom !== null) {
        const t = anchorDom.getBoundingClientRect().top + window.scrollY;
        top =
          document.body.getBoundingClientRect().height - window.innerHeight <
          top
            ? 0
            : t;
      }

      try {
        top === 0
          ? window.scrollTo(0, 0)
          : window.scrollTo({ top: top, behavior: "smooth" });
      } catch (error) {
        window.scrollTo(0, top);
      }
    }

    return <WrappedComp {...props} anchor={anchor} />;
  };
}
